import { useSelector } from "react-redux"

import { useQuery } from "@tanstack/react-query"
import { API_BANKS_URL } from "../constants"
import { BankRole, BankScenario, IBankMeta, IPageResponse } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

type IUseGetBanksListParams = {
  role?: BankRole
  scenario?: BankScenario
}

export async function fetchBanks(
  token: string | null,
  params: IUseGetBanksListParams | null,
  offset = 0,
  limit = 300,
) {
  const role = params?.role ? params.role : [BankRole.SENDER, BankRole.RECEIVER]

  const scenario = params?.scenario
    ? params.scenario
    : [BankScenario.M2M_PULL, BankScenario.C2C_PUSH, BankScenario.M2M_PUSH]

  const response = await axios(
    `${API_BANKS_URL}?limit=${limit}&offset=${offset}&role=${role}&scenario=${scenario}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка загрузки данных")
  }
  return response.data
}

export const useGetBanksList = (
  params: IUseGetBanksListParams | null,
  disableToken = false,
) => {
  const token = useSelector((state: RootState) => state.auth.token)

  const enabled = disableToken
    ? true
    : Boolean(token) && typeof params !== "undefined"

  return useQuery<IPageResponse<IBankMeta>>({
    queryKey: ["banks-list"],
    queryFn: () => fetchBanks(token, params),
    enabled,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  })
}
